import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import ChannelCard from "../Atomics/ChannelCard/ChannelCard";
import Paginate from "../Atomics/Paginate/Paginate";
import { useState, useContext, useEffect } from "react";
import { formatSubscriberCount } from "../../utils/k&mConvertor";
import { ChannelContext } from "../../context/channels";
import {
  usersAllChannelsFetcher,
  paginate,
  campaignFetcher,
} from "../../api/requests";
import { ProfileContext } from "../../context/profile";
import { channelFetcher } from "../../api/requests";
import LogoutModal from "../Navigation/LogoutModal";
import { Spinner } from "react-bootstrap";
import { useSelectedChannels } from "../../context/selectedChannels";
import LoadingIndicator from "../Atomics/Loading/Loading";
import { useLocation } from "react-router-dom";

const ChannelList = ({
  mine,
  page,
  select,
  tab,
  limitedCardNumber,
  campaign,
  searchedText,
}) => {
  const { channels, updateChannels, isLoadingChannels } =
    useContext(ChannelContext);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationInfo, setPaginationInfo] = useState({});
  const { profile } = useContext(ProfileContext);
  const [showDel, setShowDel] = useState(false);
  const [id, setId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { selectedChannels, addChannel } = useSelectedChannels();
  const [toBeShownChannels, setToBeShownChannels] = useState(channels);
  const [showPagination, setShowPagination] = useState(true);
  const [alertText, setAlertText] = useState("");
  const location = useLocation();
  const isAdmin = location.state?.admin;

  useEffect(() => {
    if (!campaign) return;

    const getCampaigns = async () => {
      try {
        const data = mine
          ? await campaignFetcher.all()
          : await campaignFetcher.getActiveCampaigns();

        if (data?.count) {
          setToBeShownChannels({ results: data.results });
          setTotalCount(data.count);
          setShowPagination(false);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    getCampaigns();
  }, [campaign, mine]);

  useEffect(() => {
    if (selectedChannels.length > limitedCardNumber) {
      setAlertText(
        `شما مجاز به انتخاب حداکثر ${limitedCardNumber} مورد هستید.`
      );
    } else {
      setAlertText("");
    }
  }, [limitedCardNumber, selectedChannels, tab]);

  const fetchChannels = async () => {
    if (campaign) return;

    setIsLoading(true);

    try {
      let data;

      if (tab === "کانال های منتخب") {
        setShowPagination(false);

        // Prefer server source of truth for previously chosen channels
        const previouslySelectedChannels =
          await channelFetcher.favoriteChannels();

        if (previouslySelectedChannels?.results) {
          setToBeShownChannels({
            ...channels,
            results: previouslySelectedChannels.results,
          });
          setTotalCount(previouslySelectedChannels.count || 0);
        } else {
          // Fallback to local selection if server returns nothing
          const filteredChannels =
            channels.results?.filter((item) =>
              selectedChannels.some((selected) => selected.id === item?.id)
            ) || [];
          setToBeShownChannels({
            ...channels,
            results: filteredChannels,
          });
          setTotalCount(filteredChannels.length);
        }
      } else {
        if (mine && profile.user) {
          data = await usersAllChannelsFetcher.get(profile.user);
        } else {
          if (tab === "همه") {
            setShowPagination(true);

            const previouslySelectedChannels =
              await channelFetcher.favoriteChannels();

            previouslySelectedChannels.results.forEach((item) =>
              addChannel({ id: item.id, name: item.name, owner: item.owner.id })
            );

            data = channels;
          } else data = channels;
        }

        setToBeShownChannels(data);
        setPaginationInfo(data);
        setTotalCount(data.count);
      }
    } catch (error) {
      console.error("Error fetching channels:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = async (arg) => {
    setIsLoading(true);

    try {
      let res;

      if (typeof arg === "string") {
        const startIndex = arg.indexOf("api") + 3;
        res = await paginate.get(arg.slice(startIndex));
      } else if (typeof arg === "object" && arg.baseUrl && arg.page) {
        res = await paginate.getByNumber(arg.baseUrl, arg.page);
      } else {
        res = arg;
      }

      updateChannels(res);
      setPaginationInfo(res);
      setTotalCount(res.count);
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteItem = (id) => {
    setShowDel(true);
    setId(id);
  };

  const handleClose = () => {
    setShowDel(false);
  };

  const handleDelete = async () => {
    try {
      await channelFetcher.delete(id);

      setToBeShownChannels((prevChannels) => {
        const updatedOwnedChannels = prevChannels.owned_channels.filter(
          (channel) => channel.id !== id
        );

        const updatedAdminChannels = prevChannels.admin_channels.filter(
          (channel) => channel.id !== id
        );

        return {
          ...prevChannels,
          owned_channels: updatedOwnedChannels,
          admin_channels: updatedAdminChannels,
        };
      });

      setShowDel(false);
    } catch (error) {
      console.error("Error deleting channel:", error);
    }
  };

  useEffect(() => {
    const hasActiveSearch = (searchedText || "").trim().length > 0;
    if (!campaign && !hasActiveSearch) {
      fetchChannels();
    }
  }, [
    profile.user,
    mine,
    channels,
    tab,
    selectedChannels,
    campaign,
    searchedText,
  ]);

  // Apply server-side search when searchedText is present
  useEffect(() => {
    const run = async () => {
      if (campaign) return;
      const term = (searchedText || "").trim();
      if (!term) {
        // reset to full list when search cleared
        try {
          setIsLoading(true);
          await fetchChannels();
          setShowPagination(true);
        } finally {
          setIsLoading(false);
        }
        return;
      }

      try {
        setIsLoading(true);
        // keep pagination during search (page_size same as default view)
        const res = await channelFetcher.getConfirmedChannelsWithSearch(
          term,
          12
        );
        setToBeShownChannels(res);
        setPaginationInfo(res);
        setShowPagination(true);
        setTotalCount(res?.count || 0);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };

    run();
  }, [searchedText, campaign]);

  const [channelView, setChannelView] = useState(0);

  const handleChannelClick = () => {
    if (!mine) {
      setChannelView(channelView + 1);
    }
  };

  return (
    <>
      <div
        className="video-block section-padding"
        style={{
          paddingRight: "30px",
          paddingLeft: "30px",
        }}
      >
        {!isLoading ? (
          <Row>
            {!mine && (
              <Col md={12}>
                <SectionHeader heading={campaign ? "پویش ها" : "کانال ها"} />
                {alertText && (
                  <Row style={{ color: "red" }} className="mr-1 mb-3">
                    {alertText}
                  </Row>
                )}
              </Col>
            )}

            {!mine ? (
              isLoadingChannels ? (
                <LoadingIndicator />
              ) : (
                toBeShownChannels?.results?.map((item, index) => (
                  <Col
                    key={index}
                    xl={3}
                    sm={6}
                    className="mb-3"
                    onClick={handleChannelClick}
                  >
                    <ChannelCard
                      total_video_count={item?.total_video_count}
                      imgAlt={item.name}
                      imgSrc={campaign ? item?.banner : item?.avatar}
                      views={item?.counted_view}
                      videoViews={item?.total_video_views || 0}
                      channelName={item.name}
                      subscriberCount={formatSubscriberCount(
                        item.subscribe_count
                      )}
                      outline
                      mine={mine}
                      imgHref={
                        campaign
                          ? `/single-channel/${item.id}/?campaign=true`
                          : `/single-channel/${item.id}`
                      }
                      channelHref={
                        campaign
                          ? `/single-channel/${item.id}/?campaign=true`
                          : `/single-channel/${item.id}`
                      }
                      page="noVideo"
                      channelId={item?.id}
                      select={select}
                      channelOwner={item?.owner?.id}
                      campaign={campaign}
                    />
                  </Col>
                ))
              )
            ) : null}

            {mine &&
              toBeShownChannels?.results?.map((item, index) => (
                <Col
                  key={index}
                  xl={3}
                  sm={6}
                  className="mb-3"
                  onClick={handleChannelClick}
                >
                  <ChannelCard
                    total_video_count={item?.total_video_count}
                    imgAlt={item.name}
                    imgSrc={campaign ? item.banner : item.avatar}
                    views={item.counted_view}
                    videoViews={item?.total_video_views || 0}
                    channelName={item.name}
                    subscriberCount={formatSubscriberCount(
                      item.subscribe_count
                    )}
                    outline
                    mine={mine}
                    imgHref={`/single-channel/${item.id}/?campaign=true`}
                    channelHref={`/single-channel/${item.id}/?campaign=true`}
                    page="noVideo"
                    channelId={item?.id}
                    onDelete={() => handleDeleteItem(item.id)}
                    moreAdress={`/myVideos/${item?.id}`}
                    campaign={campaign}
                    activeCampaign={item?.activation}
                  />
                </Col>
              ))}

            {mine &&
              !isAdmin &&
              toBeShownChannels?.owned_channels?.map((item, index) => (
                <Col
                  key={index}
                  xl={3}
                  sm={6}
                  className="mb-3"
                  onClick={handleChannelClick}
                >
                  <ChannelCard
                    total_video_count={item?.total_video_count}
                    imgAlt={item.name}
                    imgSrc={item.avatar}
                    views={item.counted_view}
                    videoViews={item?.total_video_views || 0}
                    channelName={item.name}
                    subscriberCount={formatSubscriberCount(
                      item.subscribe_count
                    )}
                    outline
                    mine={mine}
                    imgHref={`/single-channel/${item.id}`}
                    channelHref={`/single-channel/${item.id}`}
                    page="noVideo"
                    channelId={item?.id}
                    onDelete={() => handleDeleteItem(item.id)}
                    moreAdress={`/myVideos/${item?.id}`}
                  />
                </Col>
              ))}

            {mine &&
              isAdmin &&
              toBeShownChannels?.admin_channels?.map((item, index) => (
                <Col
                  key={index}
                  xl={3}
                  sm={6}
                  className="mb-3"
                  onClick={handleChannelClick}
                >
                  <ChannelCard
                    total_video_count={item?.total_video_count}
                    imgAlt={item.name}
                    imgSrc={item.avatar}
                    views={item?.counted_view}
                    videoViews={item?.channel?.total_video_views || 0}
                    channelName={item.name}
                    subscriberCount={formatSubscriberCount(
                      item.subscribe_count
                    )}
                    outline
                    mine={mine}
                    imgHref={`/single-channel/${item?.id}`}
                    channelHref={`/single-channel/${item?.id}`}
                    page="noVideo"
                    channelId={item?.id}
                    onDelete={() => handleDeleteItem(item?.id)}
                    moreAdress={`/myVideos/${item?.id}`}
                    admin={true}
                  />
                </Col>
              ))}
          </Row>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "200px" }}
          >
            <Spinner animation="border" role="status" />
          </div>
        )}
      </div>

      {!mine && showPagination && (
        <Paginate
          count={totalCount}
          value={paginationInfo}
          onPageChange={handlePageChange}
          limit={12}
        />
      )}

      {showDel && (
        <LogoutModal
          show={showDel}
          type="delete"
          name="کانال"
          handleClose={handleClose}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
};

export default ChannelList;
